import React from "react";
import MissionVisionImage from "../../assets/about-us/MissionVisionImage.png";
import { Eye, Target } from "../Icons";

const MissionVisionSection = () => {
  return (
    <section className="bg-[#F5F5F5] px-4 py-12 sm:px-6 sm:py-16 lg:px-8 lg:py-20">
      <div className="mx-auto max-w-[1728px]">
        <div className="grid items-start gap-5 lg:grid-cols-3 lg:gap-6">
          <article className="bg-white px-5 py-10 sm:px-8 sm:py-14 lg:px-[34px] lg:py-20">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#F5F5F5] sm:h-[60px] sm:w-[60px]">
              <Target />
            </div>

            <h3 className="mt-6 text-[26px] font-bold leading-tight text-black sm:mt-8 sm:text-[32px] sm:leading-[38px]">
              Our Mission
            </h3>

            <p className="mt-4 text-base text-justify leading-6 text-black sm:text-lg sm:leading-[23px] lg:text-xl">
              Empowering the k12 with AI-powered immersive and adaptive STEAM
              education through technology-driven interactive and gamified
              learning experiences.
            </p>
          </article>

          <div className="bg-white p-2 sm:p-3">
            <img
              src={MissionVisionImage}
              alt="STEAM Minds leadership session"
              className="h-auto w-full object-contain"
            />
          </div>

          <article className="bg-white px-5 py-10 sm:px-8 sm:py-14 lg:self-end lg:px-8 lg:pb-24 lg:pt-16">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#F5F5F5] sm:h-[60px] sm:w-[60px]">
              <Eye />
            </div>

            <h3 className="mt-6 text-[26px] font-bold leading-tight text-black sm:mt-8 sm:text-[32px] sm:leading-[38px]">
              Our Vision
            </h3>

            <p className="mt-4 text-base text-justify leading-6 text-black sm:text-lg sm:leading-[23px] lg:text-xl">
              Developing an AI-powered personalized, interactive, adaptive and
              immersive VR enabled 3D learning platform for students.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
};

export default MissionVisionSection;
